import React from 'react';

// Custom Wind Marker Component
export default function WindMarker({ x, y, direction }) {
  // Assuming your data point object has a 'direction' property in degrees
  const radius = 8; // Marker size

  // Wind direction is usually from North (0 deg) clockwise.
  // We adjust to Canvas/SVG 0 deg (East) and rotate to match the direction.
  const angle = ((direction + 90) * Math.PI) / 180;

  // Define the "pizza slice" as an SVG path
  // Start at center (0, 0), go along an arc, and close the path
  const startAngle = angle - Math.PI / 4 / 2; // 45 degree slice
  const endAngle = angle + Math.PI / 4 / 2;
  const startX = radius * Math.cos(startAngle);
  const startY = radius * Math.sin(startAngle);
  const endX = radius * Math.cos(endAngle);
  const endY = radius * Math.sin(endAngle);

  // SVG path commands (M: Move to, L: Line to, A: Arc, Z: Close path)
  const pathData = `M 0 0 L ${startX} ${startY} A ${radius} ${radius} 0 0 1 ${endX} ${endY} Z`;

  return (
    <g transform={`translate(${x}, ${y})`}>
      {/* Draw the "pizza slice" part first */}
      <path d={pathData} fill="black" />
      {/* Draw the outer circle */}
      <circle r={radius} fill="none" stroke="black" strokeWidth={1} />
    </g>
  );
}
